module.exports = "/dist/c162d257f5e9f9b108a96a604cfb2132.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-700italic.woff
// module id = 134
// module chunks = 0